import { ingredientsQuery } from '@/api/ingredients/ingredientQueries';
import { FilterButton } from '@/components/common/FilterButton';
import { Heading } from '@/components/common/Heading';
import { Section } from '@/components/common/Section';
import { IngredientCard } from '@/components/ingredients/IngredientCard';
import { useQuery } from '@tanstack/react-query';
import { useMemo, useState } from 'react';

export const IngredientsPage = () => {
  const { data: ingredients } = useQuery(ingredientsQuery());
  const [selectedFilters, setSelectedFilters] = useState<Array<string>>([]);

  const ingredientNames = useMemo(
    () => Object.keys(ingredients?.data ?? {}),
    [ingredients?.data],
  );

  const filteredIngredients = useMemo(() => {
    if (selectedFilters.length === 0) {
      return ingredientNames;
    }
    return ingredientNames.filter((name) => selectedFilters.includes(name));
  }, [selectedFilters, ingredientNames]);

  const handleFilterToggle = (name: string) => {
    if (name === 'All') {
      setSelectedFilters([]);
      return;
    }

    setSelectedFilters((prev) =>
      prev.includes(name)
        ? prev.filter((filter) => filter !== name)
        : [...prev, name],
    );
  };

  return (
    <main>
      <Section>
        <Heading as="h1" size="h1" className="text-secondary mb-3 text-left">
          Our Supplements
        </Heading>

        <p className="mb-7.5 max-w-150">
          The focus is optimal absorption, ensuring your body receives each
          beneficial ingredient to the fullest.
        </p>

        <div className="no-scrollbar mb-14 flex flex-nowrap gap-2.5 overflow-scroll lg:flex-wrap">
          {['All', ...ingredientNames].map((name) => (
            <FilterButton
              key={name}
              isSelected={
                (name === 'All' && selectedFilters.length === 0) ||
                selectedFilters.includes(name)
              }
              onClick={() => handleFilterToggle(name)}
            >
              {name}
            </FilterButton>
          ))}
        </div>

        <div className="flex flex-col gap-20">
          {filteredIngredients.map((name) => (
            <IngredientCard key={name} ingredientName={name} />
          ))}
        </div>
      </Section>
    </main>
  );
};
